// Function to check dynamic for any array, object or string that are not empty
export const isEmptyValue = value => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0)
    return true;
  return false;
};

export const scorefields = [
        { type: "pm", key: "pm_replies", originalKey: "replies", label: "Replies to PM inquiries in a timely manner" },
        { type: "pm", key: "finishes", originalKey: "finishes", label: "Finishes project on time" },
        { type: "pm", key: "independent", originalKey: "independent", label: "Independent and reliable" },
        { type: "qa", key: "qa_follows", originalKey: "follows", label: "Follows instructions" },
        { type: "qa", key: "qa_translation", originalKey: "translation", label: "Translation quality" },
        { type: "qa", key: "qa_replies", originalKey: "replies", label: "Replies to QA inquiries in a timely manner" },
    ];

export const navTabsScoop = [
  { label: "On-Going", value: "tab-ongoing" },
  { label: "PM Ready", value: "tab-pm-ready" },
  { label: "Delivery", value: "tab-to-be-delivered" },
  { label: "Completed", value: "tab-completed" },
  { label: "Approved", value: "tab-approved" },
  { label: "Assign", value: "tab-assigned" },
  { label: "Upcoming", value: "tab-my-upcoming" },
  { label: "QA-Issues", value: "tab-qa-issue" },
  { label: "Due Today", value: "tab-due-today" },
  { label: "Due Tomorrow", value: "tab-due-tomorrow" },
  { label: "QA Ready", value: "tab-qa-ready" },
  { label: "My Projects", value: "tab-my-projects" },
  { label: "All", value: "tab-all" },
  { label: "Missing PO", value: "tab-poMissing" },
  { label: "Last Seen", value: "tab-lastSeen" },
];

export const navTabsScoopFreelance = [
  { label: "Ongoing", value: "tab-ongoing", countKey: "tab-ongoing" },
  { label: "Requested", value: "tab-requested", countKey: "tab-requested" },
  { label: "Waiting", value: "tab-waiting", countKey: "tab-waiting" }, // Fixed countKey
  { label: "Completed", value: "tab-completed", countKey: "tab-completed" },
  {
    label: "Invoice Ready",
    value: "tab-invoice-ready",
    countKey: "tab-invoice-ready",
  },
  { label: "All", value: "tab-all", countKey: "tab-all" },
];
export const invoiceTabsCountFreelance = [
  { label: "All invoices", value: "all", countKey: "all" },
  {
    label: "Waiting on approval",
    value: "waiting_on_approval",
    countKey: "waiting",
  },
  { label: "Outstanding", value: "outstanding", countKey: "outstanding" },
  { label: "Overdue", value: "overdue", countKey: "overdue" },
  { label: "Paid", value: "paid", countKey: "paid" },
  { label: "Cancelled", value: "cancelled", countKey: "cancelled" },
];

export const navTabsTms = [
  { label: "Requested", value: "Requested" },
  { label: "In Progress", value: "inProgress" },
  { label: "Due Today", value: "DueToday" },
  { label: "Due Tomorrow", value: "DueTomorrow" },
  { label: "Overdue", value: "Overdue" },
];

export const linguistInvoiceTabs = [
  { label: "Outstanding", value: "outstanding" },
  { label: "Waiting On Approval", value: "waitingApproval" },
  { label: "Overdue", value: "overdue" },
  { label: "Paid", value: "paid" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Not Exported", value: "notExported" },
  { label: "All Invoices", value: "allinvoice" },
  { label: "Not Requested", value: "notRequested" },
];

export const clientInvoiceTabs = [
  { label: "Outstanding", value: "Open", countValue: "outstanding" },
  { label: "Overdue", value: "Overdue", countValue: "overdue" },
  { label: "Partly Paid", value: "Partly Paid", countValue: "partpaid" },
  { label: "Paid", value: "Completed", countValue: "paid" },
  { label: "Cancelled", value: "Cancelled", countValue: "cancelled" },
  { label: "Credited", value: "Credited", countValue: "credited" },
  { label: "Not Exported", value: "Not-exported", countValue: "notExported" },
  { label: "All Invoices", value: "all", countValue: "allinvoice" },
  {
    label: "Group Outstanding",
    value: "group-outstanding",
    countValue: "outstanding",
  },
];

export const linguistStatusDropdown = [
  { label: "Open", value: "Open" },
  { label: "Approved", value: "Approved" },
  { label: "Partly Paid", value: "Partly Paid" },
  { label: "Paid", value: "Paid" },
  { label: "Completed", value: "Completed" },
  { label: "Overdue", value: "Overdue" },
  { label: "Cancel", value: "Cancel" },
  { label: "Not requested", value: "Not requested" },
];
export const clientStatusDropdown = [
  { label: "Outstanding", value: "Open" },
  { label: "Paid", value: "Paid" },
  { label: "Completed", value: "Completed" },
  { label: "Overdue", value: "Overdue" },
  { label: "Cancel", value: "Cancel" },
  { label: "Irrecoverable", value: "Irrecoverable" },
];

export const scoopStatMap = {
  currentDayAmt: { title: "Current Day", color: "#FFC107" },
  dueTodayAmt: { title: "Due Today", color: "#00BCD4" },
  inProgressAmt: { title: "In Progress", color: "#00BCD4" },
  tobeAssignAmt: { title: "To be Assigned", color: "#FF4081" },
  deliveredAmt: { title: "Delivered", color: "#9C27B0" },
  allProjectAmt: { title: "All", color: "#9C27B0" },
  dueTomorrowAmt: { title: "Due Tomorrow", color: "#C0E218" },
  qaReadyAmt: { title: "QA Ready", color: "#C0E218" },
  tobeDeliveredAmt: { title: "To be Delivered", color: "#FFC107" },
  approvedAmt: { title: "Approved", color: "#FF4081" },
};

export const jobStatMap = {
  requestedJobAmt: { title: "Requested", color: "#FFC107" },
  inProgressJobAmt: { title: "In Progress", color: "#00BCD4" },
  preparationJobAmt: { title: "Inpreparation", color: "#C0E218" },
  overdueJobAmt: { title: "Overdue", color: "#FF4081" },
  deliveredJobAmt: { title: "Delivered", color: "#9C27B0" },
  approvedJobAmt: { title: "Approved", color: "#FFC107" },
  dueTodayJobAmt: { title: "Due Today", color: "#00BCD4" },
  dueTomorrowJobAmt: { title: "Due Tomorrow", color: "#00BCD4" },
};

export const payableStateMap = {
  allpayableAmt: { title: "All ", color: "#FFC107" },
  submitPayable: { title: "Submitted", color: "#00BCD4" },
  approvedPayable: { title: "Approved", color: "#C0E218" },
  outstandRmndrPayable: { title: "Outstanding Remainder", color: "#FF4081" },
  paidPayable: { title: "Paid", color: "#9C27B0" },
  cancelPayable: { title: "Cancelled", color: "#FFC107" },
  overduePayable: { title: "Overdue", color: "#00BCD4" },
  outstandingPayable: { title: "Outstanding", color: "#C0E218" },
  todayPayable: { title: "Due Today", color: "#FF4081" },
  // "allPaidAmt": { title: "All Paid", color: "#FFC107" },
};

export const receivableStateMap = {
  allReceivablesAmt: { title: "All", color: "#FFC107" },
  toBesentReceivables: { title: "To Be Sent", color: "#00BCD4" },
  outstandRmndrReceivables: {
    title: "Outstanding Remainder",
    color: "#C0E218",
  },
  paidReceivables: { title: "Paid", color: "#FF4081" },
  cancelReceivables: { title: "Cancelled", color: "#9C27B0" },
  irRecoverableReceivables: { title: "Irrecoverable", color: "#FFC107" },
  outstandingReceivables: { title: "Outstanding", color: "#00BCD4" },
  overdueReceivables: { title: "Overdue", color: "#C0E218" },
  todayReceivables: { title: "Due Today", color: "#FF4081" },
  // allPaidRecvbl: { title: "All Paid", color: "#FFC107" },
};

export const filterCriteria = [
  { value: "direct_client", label: "Direct Client" },
  { value: "indirect_client", label: "Indirect Client (Account)" },
  { value: "timeframe_scoop", label: "Scoop Due Date" },
  { value: "timeframe_job", label: "Job Due Date" },
  { value: "language_pair", label: "Language Combination" },
  { value: "project_type", label: "Project Type" },
  { value: "scoop_status", label: "Scoop Status" },
  { value: "job_status", label: "Job Status" },
  { value: "pc", label: "Project Coordinator (PC)" },
  { value: "pm", label: "Project Manager (PM)" },
  { value: "qa", label: "QA" },
  { value: "linguist_in_job", label: "Linguist in the Job" },
  { value: "scoop_name", label: "Scoop Name" },
  { value: "email_subject", label: "Email Subject" },
  { value: "po_number", label: "PO Number" },
  { value: "job_type", label: "Job Type" },
  { value: "project_volume", label: "Project Volume" },
  { value: "project_number", label: "Project Number" },
  { value: "project_price", label: "Scoop Price" },
  { value: "job_price", label: "Job Price" },
  { value: "project_profit_margin", label: "Project Margin" },
  { value: "scoop_profit_margin", label: "Scoop Margin" },
  { value: "pm_score_rating", label: "Pm score" },
  { value: "qa_score_rating", label: "QA Score" },
  { value: "project_update_type_lqa", label: "Update Type LQA" },
  { value: "project_update_type_follow_up", label: "Update Type Follow Up" },
  { value: "project_update_type_qar", label: "Update Type QAR" },
];

export const filterOperator = [
  { value: "contains", label: "Contains" },
  { value: "not_contains", label: "Not Contains" },
];

export const filterOperatorRange = [
  { value: "above", label: "Above" },
  { value: "below", label: "Below" },
  { value: "between", label: "Between" },
];

export const ratingOptions = [
  { value: 1, label: "1 Star" },
  { value: 2, label: "2 Star" },
  { value: 3, label: "3 Star" },
  { value: 4, label: "4 Star" },
  { value: 5, label: "5 Star" },
];

export const lqaResult = [
  { label: "Pass", value: "Pass" },
  { label: "Fail", value: "Fail" },
];

//for highlight sidebar menu items
export const menuRoutes = {
  resourceInternalOtherMenu: ["/manage/internal", "/viewinternal/"],
  resourceExternalOtherMenu: ["/manage/external", "/viewExternal/", "/user/profile-update-requests"],
  clientOtherMenu: ["/client/form", "/viewclient", "/client/importcsv"],
  clientAccountOtherMenu: ["/client/accountdetail"],
  clientInvoiceOtherMenu: ["/client/invoice"],
  resourcesOtherMenu: ["/resource-search", "/resource-advance-search"],
  invoiceOtherMenu: ["/viewinvoice", "/invoice-linguist-jobs", "/linguistinvoicecreate"],
  dashboardOtherMenu: ["/general/createproject", "/general/scoop/", "/general/jobspage/"],
};

//only allow following routes to freelancer
export const freeLancerRoutes = {
  exact: ["/"],
  prefix: [
    // "/freelance/report",
    "/freelance/invoice",
    "/viewinvoicelinguist",
    "/invoice-linguist-jobs",
    "/linguistinvoicecreate",
    "/profile",
    "/manage/external/",
    "/jobdetails/",
    "/holiday-planner",
    "/user/profile-update-requests",
  ],
};

export const getCenteredPopupSize  = (widthPercent = 0.6, heightPercent = 0.6) => {
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;

  const width = screenWidth * widthPercent;
  const height = screenHeight * heightPercent;

  const left = (screenWidth - width) / 2;
  const top = (screenHeight - height) / 2;

  return { width, height, left, top };
}
